import type {IUserStore} from "./interfaces/IUserStore";
import type {TUserDefinition} from "./types/TUserDefinition";

import {useCrudStore} from "@/stores/CrudStore/CrudStore";
import {IUserUpdate} from "@/stores/UserStore/interfaces/IUserUpdate";
import {IUser} from "@/stores/UserStore/interfaces/IUser";

export const useUserStore = () =>
    useCrudStore<IUser, IUserStore, IUserUpdate, TUserDefinition, IUserStore>({
        storeId: 'userStore',
        route: '/portal/{guid}/user',
        initialize: true,
        langSection: 'stores.user',
    });
